(function () {
  if (window.__lgkWishlistBound) return;
  window.__lgkWishlistBound = true;

  var STORAGE_KEY = 'lgk:wishlist';
  var EVENT = 'lgk:wishlist:change';
  var toastTimer;
  var syncTimer;
  var syncing = false;
  var customerCfg = window.__lgkCustomerWishlist || { loggedIn: false, handles: [], syncUrl: '/apps/lgk-wishlist' };

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles, options) {
    options = options || {};
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* Safari privé */
    }
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { handles: handles } }));
    if (!options.skipSync) syncToAccount(handles);
  }

  function syncToAccount(handles) {
    if (!customerCfg.loggedIn || !customerCfg.syncUrl) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      if (syncing) return;
      syncing = true;
      fetch(customerCfg.syncUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handles: handles })
      }).catch(function () { /* proxy pas encore actif */ })
        .finally(function () { syncing = false; });
    }, 700);
  }

  function mergeOnLogin() {
    if (!customerCfg.loggedIn) return;
    var local = read();
    var remote = Array.isArray(customerCfg.handles) ? customerCfg.handles : [];
    var merged = [];
    remote.concat(local).forEach(function (h) {
      var handle = String(h || '').trim();
      if (handle && merged.indexOf(handle) === -1) merged.push(handle);
    });
    var changed = merged.length !== local.length;
    if (!changed) {
      for (var i = 0; i < merged.length; i++) {
        if (merged[i] !== local[i]) { changed = true; break; }
      }
    }
    if (changed) {
      write(merged);
    } else if (remote.length !== merged.length) {
      syncToAccount(merged);
    }
  }

  window.LGKWishlist = {
    getHandles: function () { return read(); },
    getCount: function () { return read().length; },
    has: function (handle) { return read().indexOf(handle) !== -1; },
    isLoggedIn: function () { return !!customerCfg.loggedIn; },
    add: function (handle) {
      var h = String(handle || '').trim();
      if (!h) return;
      var list = read();
      if (list.indexOf(h) === -1) write([h].concat(list));
    },
    remove: function (handle) {
      write(read().filter(function (x) { return x !== handle; }));
    },
    toggle: function (handle) {
      if (this.has(handle)) {
        this.remove(handle);
        return false;
      }
      this.add(handle);
      return true;
    },
    clear: function () { write([]); }
  };

  function showToast(message) {
    var toast = document.getElementById('lgk-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'lgk-wishlist-toast';
      toast.className = 'lgk-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function updateButton(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var active = LGKWishlist.has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = btn.querySelector('.lgk-wishlist-btn__label');
    if (label) {
      label.textContent = active ? 'Retirer de ma wishlist' : 'Ajouter à ma wishlist';
    }
    btn.setAttribute('aria-label', active ? 'Retirer de ma wishlist' : 'Ajouter à ma wishlist');
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-lgk-wishlist-btn]').forEach(updateButton);
  }

  function updateCountBadges() {
    var count = LGKWishlist.getCount();
    document.querySelectorAll('[data-lgk-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('is-visible', count > 0);
      el.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
    });
  }

  function toastForToggle(added) {
    if (customerCfg.loggedIn) {
      showToast(added ? 'Ajouté à votre wishlist ❤️ (compte synchronisé)' : 'Retiré de votre wishlist');
    } else {
      showToast(added ? 'Ajouté à votre wishlist ❤️' : 'Retiré de votre wishlist');
    }
  }

  function burstStars(btn) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var wrap = document.createElement('span');
    wrap.className = 'lgk-stars-burst';
    wrap.setAttribute('aria-hidden', 'true');

    var angles = [0, 45, 90, 135, 180, 225, 270, 315];
    var dist = btn.classList.contains('lgk-wishlist-btn--card') ? 38 : 32;

    angles.forEach(function (deg, i) {
      var rad = (deg * Math.PI) / 180;
      var particle = document.createElement('span');
      particle.className = 'lgk-stars-burst__particle';
      particle.style.setProperty('--lgk-tx', (Math.cos(rad) * dist).toFixed(1) + 'px');
      particle.style.setProperty('--lgk-ty', (Math.sin(rad) * dist).toFixed(1) + 'px');
      particle.style.setProperty('--lgk-burst-delay', (i * 0.045) + 's');
      particle.innerHTML =
        '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
          '<circle class="lgk-stars-burst__ring" cx="12" cy="12" r="9"/>' +
          '<path class="lgk-stars-burst__star" d="M12 2.5l2.2 6.8H21l-5.5 4.2 2.1 6.5L12 16.8 6.4 19.5l2.1-6.5L3 9.3h6.8z"/>' +
        '</svg>';
      wrap.appendChild(particle);
    });

    btn.appendChild(wrap);
    setTimeout(function () {
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }, 900);
  }

  function handleWishlistClick(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var added = LGKWishlist.toggle(handle);
    document.querySelectorAll('[data-lgk-wishlist-btn][data-wishlist-handle="' + handle + '"]').forEach(function (el) {
      updateButton(el);
      el.classList.add('is-pulse');
      setTimeout(function () { el.classList.remove('is-pulse'); }, 400);
      if (added) burstStars(el);
    });
    updateCountBadges();
    toastForToggle(added);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lgk-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    handleWishlistClick(btn);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('[data-lgk-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    handleWishlistClick(btn);
  });

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  function renderWishlistPage(container) {
    var grid = container.querySelector('[data-lgk-wishlist-grid]');
    var empty = container.querySelector('[data-lgk-wishlist-empty]');
    var loading = container.querySelector('[data-lgk-wishlist-loading]');
    var syncNote = container.querySelector('[data-lgk-wishlist-sync-note]');
    if (!grid) return;

    if (syncNote) syncNote.hidden = false;

    var handles = LGKWishlist.getHandles();
    if (loading) loading.hidden = false;
    grid.innerHTML = '';
    if (empty) empty.hidden = true;

    if (!handles.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var valid = products.filter(Boolean);
      if (loading) loading.hidden = true;

      if (!valid.length) {
        if (empty) empty.hidden = false;
        return;
      }

      valid.forEach(function (product) {
        var li = document.createElement('li');
        li.className = 'lgk-wishlist__item';
        var img = product.featured_image || '';
        var price = product.variants && product.variants[0] ? product.variants[0].price : 0;
        var available = product.available;

        li.innerHTML =
          '<article class="lgk-wishlist-card">' +
            '<a href="' + product.url + '" class="lgk-wishlist-card__media">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy" width="320" height="320">' : '') +
            '</a>' +
            '<div class="lgk-wishlist-card__body">' +
              '<a href="' + product.url + '" class="lgk-wishlist-card__title">' + product.title + '</a>' +
              '<p class="lgk-wishlist-card__price">' + formatMoney(price) + '</p>' +
              '<div class="lgk-wishlist-card__actions">' +
                (available
                  ? '<a href="' + product.url + '" class="button button--primary button--sm">Voir le produit</a>'
                  : '<span class="text-subdued">Indisponible</span>') +
                '<button type="button" class="lgk-wishlist-btn lgk-wishlist-btn--text is-active" data-lgk-wishlist-btn data-wishlist-handle="' + product.handle + '" aria-pressed="true">' +
                  '<span class="lgk-wishlist-btn__label">Retirer</span>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</article>';
        grid.appendChild(li);
      });

      updateAllButtons();
    });
  }

  document.addEventListener(EVENT, function () {
    updateAllButtons();
    updateCountBadges();
    var page = document.querySelector('[data-lgk-wishlist-page]');
    if (page) renderWishlistPage(page);
  });

  function init() {
    mergeOnLogin();
    updateAllButtons();
    updateCountBadges();
    var page = document.querySelector('[data-lgk-wishlist-page]');
    if (page) renderWishlistPage(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
